<template>
  <div>
    <div  v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control-select" @change="cambiarDatos($event)" :disabled="deshabilitado">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de trámite </option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de trámites</option>
        <option v-for="TipoTramite in TiposTramites" :value="TipoTramite.TipoTramiteId" :key="TipoTramite.TipoTramiteId">{{TipoTramite.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposTramites: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      
      this.$store.dispatch("A_SICCIJ_Catalogo_Establecer013TipoTramite", parametros);
    },
    methods: {
      cargaCatalogoTiposTramites() {        
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba      
                
        axios.post(api.conexion + api.SICCIJ.catalogos.C013TiposTramites, this.parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.TiposTramites = respuesta.data.TiposTramites;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.TiposTramites = respuesta.data.TiposTramites.filter(cond => this.parametros.filtros.some(tipo => tipo == cond.TipoTramiteId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_SICCIJ_Catalogo_Establecer013TipoTramite", parametros);
        //this.$emit("valorParaElPadre", evento);
        this.$emit("valorParaElPadre", [evento,this.TiposTramites[this.idDelModelo-1]]);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoTiposTramites();
    }
  }
</script>

<style scoped>
.form-control-select {
        background-color: white;
        color: rgb(63, 62, 62);
        border: none;
        position: relative;
        top: 5px;
        left: 20px;
        width: 300px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Comun/Catalogos/013TiposTramites.vue